import { theme } from "../../Styles";
import { CONTRACT_NAME, currentWebsiteURL } from "../config";
import { getWalletSession } from "./wallet_functions";

export const handleReceiverAdd = (setPaymentReceivers, paymentReceivers) => {
    setPaymentReceivers([...paymentReceivers, { wax_address: '', shares: ''}])
}

export const handleReceiverRemove = (setPaymentReceivers, paymentReceivers, index) => {
    const list = [...paymentReceivers];
    list.splice(index, 1);
    setPaymentReceivers(list);
}


export const handleReceiverValueChange = (e, index, paymentReceivers, setPaymentReceivers) => {
    const {name, value} = e.target;
    const list = [...paymentReceivers];

    if (name === "shares") {
        // If the input is an empty string, allow it.
        if (value === "") {
            list[index][name] = value;
        } else {
            // Parse the value as an integer and assign it only if it's not NaN.
            const intValue = parseInt(value, 10);
            if (!isNaN(intValue)) {
                list[index][name] = intValue;
            }
        }
    } else {
        list[index][name] = value;
    }
    
    setPaymentReceivers(list);
}


export const handleWhitelistAdd = (setWhitelistRequirements, whitelistRequirements) => {
    setWhitelistRequirements([...whitelistRequirements, {filter_by: "", quantity:"", collection_name:"", schema_name:"", template_id:"", attributes:[], image:"" }])
}

export const handleWhitelistRemove = (setWhitelistRequirements, whitelistRequirements, index) => {
    const list = [...whitelistRequirements];
    list.splice(index, 1);
    setWhitelistRequirements(list);
}


export const handleWhitelistValueChange = (e, index, whitelistRequirements, setWhitelistRequirements) => {
    const {name, value} = e.target;
    const list = [...whitelistRequirements];
    list[index][name] = value;
    setWhitelistRequirements(list);
    console.log(list)
}



export const handleNftPriceAdd = (setNftPrices, nftPrices) => {
    setNftPrices(prevState => ({
        ...prevState,
        prices: [...prevState.prices, {
            filter_by: "", 
            quantity: "", 
            collection_name: "", 
            schema_name: "", 
            template_id: "", 
            attributes: [], 
            distribution_method: 0, 
            discount_percent: 0, 
            wax_address: "", 
            image: ""
        }]
    }));
}


export const handleNftPriceRemove = (setNftPrices, nftPrices, index) => {
    const newPrices = [...nftPrices.prices];
    newPrices.splice(index, 1);

    setNftPrices(prevState => ({
        ...prevState,
        prices: newPrices
    }));
}

export const handleNftPriceOpChange = (e, setNftPrices) => {
    const {name, value} = e.target;
    
    setNftPrices(prevState => ({
        ...prevState,
        [name]: value
    }));

}


export const handleNftPriceQuantityChange = (e, setNftPrices) => {
    const {name, value} = e.target;
    
    const intValue = parseInt(value, 10);
    if (!isNaN(intValue) || value === "") {
        setNftPrices(prevState => ({
            ...prevState,
            [name]: value === "" ? "" : intValue
        }));
    }
}


export const handleNftPriceValueChange = (e, index, nftPrices, setNftPrices) => {
    const {name, value} = e.target;
    const newPrices = [...nftPrices.prices];
    newPrices[index][name] = value;
    

    setNftPrices(prevState => ({
        ...prevState,
        prices: newPrices
    }));

    console.log(newPrices)
}





export const handleTokenPriceAdd = (setTokenPrices, tokenPrices) => {
    setTokenPrices(prevState => ({
        ...prevState,
        prices: [...prevState.prices, {
            quantity: "", 
            precision: "",
            contract:"",
            symbol:""
        }]
    }));
}


export const handleTokenPriceRemove = (setNftPrices, nftPrices, index) => {
    const newPrices = [...nftPrices.prices];
    newPrices.splice(index, 1);

    setNftPrices(prevState => ({
        ...prevState,
        prices: newPrices
    }));
}

export const handleTokenPriceOpChange = (e, setNftPrices) => {
    const {name, value} = e.target;
    
    setNftPrices(prevState => ({
        ...prevState,
        [name]: value
    }));

}


export const handleTokenPriceQuantityChange = (e, setNftPrices) => {
    const {name, value} = e.target;
    
    const intValue = parseInt(value, 10);
    if (!isNaN(intValue) || value === "") {
        setNftPrices(prevState => ({
            ...prevState,
            [name]: value === "" ? "" : intValue
        }));
    }
}

export const handleTokenPriceValueChange = (e, index, nftPrices, setNftPrices) => {
    const {name, value} = e.target;
    const newPrices = [...nftPrices.prices];
    
    if (name === "contract") {
        // convert to lowercase
        let lowerValue = value.toLowerCase();

        // remove invalid characters
        lowerValue = lowerValue.replace(/[^a-z1-5\.]/g, "");

        // handle special case for 13 characters long
        if (lowerValue.length === 13 && !lowerValue[12].match(/[a-j]/)) {
            lowerValue = lowerValue.substring(0, 12);
        }

        // trim to 13 characters if it's too long
        if (lowerValue.length > 13) {
            lowerValue = lowerValue.substring(0, 13);
        }

        newPrices[index][name] = lowerValue;
    } 
    else if (name === "symbol") {
        // convert to uppercase
        let upperValue = value.toUpperCase();

        // remove invalid characters
        upperValue = upperValue.replace(/[^A-Z]/g, "");

        newPrices[index][name] = upperValue;
    } 
    else if (name === "precision") {
        // Parse the value as an integer and assign it only if it's not NaN or if it's an empty string.
        const intValue = parseInt(value, 10);
        if (!isNaN(intValue) || value === "") {
            newPrices[index][name] = value === "" ? "" : intValue;
        }
    } 
    else if (name === "quantity") {
        // allow only numbers and dot
        const processedValue = value.replace(/[^0-9\.]/g, "");
        
        // allow only one dot
        const splitValue = processedValue.split(".");
        if (splitValue.length > 2) {
            splitValue.splice(2);
        }
        
        const finalValue = splitValue.join(".");
        newPrices[index][name] = finalValue;
    }
    else {
        newPrices[index][name] = value;
    }
    
    setNftPrices(prevState => ({
        ...prevState,
        prices: newPrices
    }));
}


export const createNewListing = async (listing_fee, nft_prices, required_proof_nfts, fungible_prices, 
    payment_receivers, max_discount_percent,
    setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay) => {
    setEnterModalDisplay('');
    setEnterModalText('Awaiting confirmation...');
    let walletSession = await getWalletSession(setEnterModalText);
    let session = walletSession[0];
    let this_user = walletSession[1];
    let this_permission = walletSession[2];
  
    let token_prices = [];

    for(let t of fungible_prices.prices){
        let new_quantity = Number(t.quantity).toFixed(Number(t.precision)) + " " + t.symbol;
        token_prices.push({"quantity": new_quantity, "contract": t.contract})
    }

    const fixed_token_prices = {op: fungible_prices.op, quantity: fungible_prices.quantity, prices: token_prices}

    let proofs = [];

    for(let n of required_proof_nfts){
        let template_id = 0;
        if(Number(n.filter_by) == 2){
            template_id = Number(n.template_id);
        }

        proofs.push({"filter_by": n.filter_by, "quantity": n.quantity, "collection_name": n.collection_name, "schema_name": n.schema_name, "template_id": template_id, "attributes": n.attributes, "image": n.image})

    }

    let nft_p = [];

    for(let n of nft_prices.prices){
        let template_id = 0;
        if(Number(n.filter_by) == 2){
            template_id = Number(n.template_id);
        }
        nft_p.push({"filter_by": n.filter_by, "quantity": n.quantity, "collection_name": n.collection_name, "schema_name": n.schema_name, "template_id": template_id, "distribution_method": n.distribution_method, "discount_percent": Number(n.discount_percent / 100).toFixed(8), "wax_address": n.wax_address, "attributes": n.attributes, "image": n.image})
    }

    const fixed_nft_prices = {op: nft_prices.op, quantity: nft_prices.quantity, prices: nft_p}


    try {   
      const action = [
        {
            account: CONTRACT_NAME,
            name: "announcedepo",
            authorization: [
              {
                actor: this_user,
                permission: this_permission,
              },
            ],
            data: {
              user: this_user, 
              listing_fee: {"token_symbol": "8,WAX", "contract": "eosio.token"},
            },
          },

          {
            account: "eosio.token",
            name: "transfer",
            authorization: [
              {
                actor: this_user,
                permission: this_permission,
              },
            ],
            data: {
              from: this_user, 
              to: CONTRACT_NAME,
              quantity: Number(listing_fee).toFixed(8) + " WAX",
              memo: "|add_balance|"
            },
          },    
        
        {
            account: CONTRACT_NAME,
            name: "newlisting",
            authorization: [
              {
                actor: this_user,
                permission: "active",
              },
            ],
            data: {
              user: this_user, 
              name_to_list: this_user,
              nft_prices: fixed_nft_prices,
              required_proof_nfts: proofs,
              fungible_prices: fixed_token_prices,
              payment_receivers: payment_receivers,
              max_discount_percent: Number(max_discount_percent / 100).toFixed(8),
              listing_fee: {"token_symbol": "8,WAX", "contract": "eosio.token"},
            },
          },
        
      ]

      console.log(action)

      const response = await session[0].signTransaction({
        actions: action
      }, {
  
        blocksBehind: 3,
        expireSeconds: 1200,
        broadcast: true,
      })
      setLoadingDisplay('');
      setEnterButtonsDisplay('hidden');
      setEnterModalText('Processing your transaction...')
      const timer = setTimeout(() => {
        
          setEnterModalText(<span>Your listing has been created. You can view on your <span style={{color: theme.secondary}}><a href={`${currentWebsiteURL}/listings/${this_user}`}>listings page</a></span></span>);
          setLoadingDisplay('none');
          setEnterButtonsDisplay('');
    
      }, 1000);
      return () => clearTimeout(timer);
  
    } catch(e) {
      setEnterModalText(JSON.stringify(e.message));
      console.log(e)
      
    }
 
  }